import { ChallengerCore } from "../core";
import { Cdata, ChallengeType } from "../structs";
import { Challenge } from "./challenge";

interface CombinedResult {
    cres: string[];
}

interface CombinedMedia {
    media: CombinedMdata[]
}

interface CombinedMdata {
    ctype: string,
    data: string
}

interface CombinedCtype {
    ctype: number,
    ctypeName: string
}

export class CombinedChallenge extends Challenge {
    private challenges: Array<Challenge>; // Collection of challenges
	private combinedMedia: CombinedMedia;

    protected async execute(): Promise<boolean> {
        if (!this.mdata && !(await this.getMedia())) { return false; }
        return this.processMdata();
    }

    async render(parentDiv: HTMLElement): Promise<boolean> {
        if (!parentDiv) { return false; }

        this.challenges = new Array<Challenge>();

        // Create challenges and push to internal array
        if (!(await this.execute())) { return false; }

        // Render each sub-challenge in a separate div
        for (const c of this.challenges) {
            const challengeDiv = window.document.createElement("div");
            parentDiv.appendChild(challengeDiv);
            if (!(await c.render(challengeDiv))) { return false; }
        }

        return true;
    }

    // Fetch mdata of all challenges and instantiate
    protected processMdata(): boolean {
        if (!this.mdata) { return false; }
        let data: CombinedMedia; // Has array of Mdata for each sub-challenge
        try {
            this.combinedMedia = JSON.parse(this.mdata); // Has array of Mdata for each sub-challenge
            for (const d of this.combinedMedia.media) {
                const cTypeNum = parseInt(d.ctype);
                const cType = ChallengeType.valueOf(cTypeNum);
                const cData: Cdata = {
                    status: this.cdata_status,
                    result: {
                        cid: this.cdata.result.cid,
                        ctype: cTypeNum
                    },
                    message: "",
                    code: ""
                };
                this.challenges.push(
                    ChallengerCore.makeChallenge(cType, this.core, cData, this.cdata_status, d.data)
                );
            }

        } catch (e) {
            return false;
        }

        return true;
    }

    // Final result is combination of all results from contained challenges
    getChallengeResult(): [string, boolean] {
        const result: CombinedResult = {
            cres: []
        };
        let should_block = false;

        for (const c of this.challenges) {
            const [cres, block] = c.getChallengeResult();
            result.cres.push(cres);
            if (block) {
                should_block = block;
            }

        }

        return [btoa(JSON.stringify(result)), should_block];
    }

    // Returns the list of ctypes from combined challenge as well as mapped ctype name
    getCombinedCtypes(): CombinedCtype[] | undefined {
        return this.combinedMedia?.media.map((media) => {
            return {
                ctype: parseInt(media.ctype),
                ctypeName: ChallengeType.nameOf(parseInt(media.ctype))
            };
        });
    }
}
